module.exports = {"name":"youboralib","type":"lib","tech":"js","author":"Jordi Aguilar","version":"6.2.0","built":"2018-04-06","repo":"https://bitbucket.org/npaw/lib-plugin-js.git"}


//////////////////
// WEBPACK FOOTER
// ./~/youboralib/manifest.json
// module id = 30
// module chunks = 0